import { Component, ElementRef, Input, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeroComponent } from '../shared/hero/hero.component';
import { SharedService } from '../../services/shared/shared.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FirestoreService } from '../../services/firestore/firestore.service';
import { Testimonial } from '../../models/testimonials';
declare var $: any;

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [HeroComponent, CommonModule],
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit, AfterViewInit {
  testimonials: Testimonial[] = [];

  @Input() showHero: boolean = true;

  constructor(
    private sharedService: SharedService,
    private firestoreService: FirestoreService,
    private elRef: ElementRef,
    private cdr: ChangeDetectorRef // Inject ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.getAllTestimonials();
  }

  getAllTestimonials() {
    this.firestoreService.getAll('testimonials').subscribe({
      next: (data) => {
        console.log('Testimonials loaded:', data);
        // Debug each item to inspect fields coming from Firestore
        if (Array.isArray(data)) {
          data.forEach((item, idx) => {
            try {
              console.log(`testimonial[${idx}] keys:`, Object.keys(item));
              console.log(`testimonial[${idx}] raw:`, item);
            } catch (e) {
              console.warn('Could not inspect testimonial item', idx, e);
            }
          });
        }
        this.testimonials = data;
        // Ensure Angular has rendered the testimonials before initializing the jQuery/Slick plugin
        try {
          this.cdr.detectChanges();
        } catch (e) {
          // ignore if change detection can't run here
        }

        // Initialize Slick after a brief tick to allow DOM to stabilize
        setTimeout(() => {
          this.initializeSlick();
        }, 50);
      },
      error: (err) => {
        console.error('Error fetching testimonials:', err);
        this.sharedService.handleError(err, 'Erfahrungsberichte Fehler', 'Konnte Erfahrungsberichte nicht laden');
      }
    });
  }

  ngAfterViewInit() {
    // No need to initialize here since we'll do it after data load
  }

  initializeSlick(): void {
    const $slider = $(this.elRef.nativeElement).find('.testimonial-slider');
    if ($slider.length) {
      $slider.slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              autoplay: true,
              autoplaySpeed: 2000
            }
          }
        ]
      });
      console.log('Slick initialized successfully');
    } else {
      console.error('Slider element not found!');
    }
  }

  getStars(rating: number): number[] {
    const count = Math.max(0, Math.floor(Number(rating) || 0));
    return Array(count).fill(0);
  }
}